/*我的团队相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../../axios'
export default {
    getProductList: (data) => axios.get('/api/api/agent/invite/agent', data),//获取产品列表
    getProductsearch: (data) => axios.get('/api/api/agent/invite/agent/mobile', data),//我的团队搜索
}